<template>
  <section class="specs-wrapper">
    <device-specification-tab-select :tab-list="tabList"
                                     :selected-tab="currentTab"
                                     @click="setTab"/>
    <base-tabs v-model="currentTab" hide-tabs>
      <base-tab-page v-for="tabPage in tabList"
                     :key="`page${tabPage.key}`"
                     :name="tabPage.key">
        <component :is="tabPage.component"
                   :device-specification="$props.deviceSpecification"
                   :tariffList="tariffList"
                   :isPDP="true"/>
      </base-tab-page>
    </base-tabs>
  </section>
</template>

<script>
import BaseTabs from '@/components/base/tabs/base-tabs'
import BaseTabPage from '@/components/base/tabs/base-tab-page'
import DeviceSpecification from '@/components/pdp/device-specification'
import PlaceholderComponent from '@/components/common/placeholder-component'
import DeviceSpecificationTabSelect from '@/components/pdp/device-specification-tab-select'
import TariffList from '@/components/tariff-list/TariffList.vue'
import { customEvent } from '@/services/customEventBus'

export default {
  name: 'device-specs-tariff-wrapper',
  components: {
    DeviceSpecificationTabSelect,
    PlaceholderComponent,
    DeviceSpecification,
    BaseTabPage,
    BaseTabs,
    TariffList
  },
  data () {
    return {
      currentTab: 'tariffs',
      tabList: Object.freeze([
        {
          key: 'specification',
          name: this.$t('productPage.specification'),
          component: 'device-specification'
        },
        {
          key: 'tariffs',
          name: this.$t('productPage.tariffs'),
          component: 'tariff-list'
        }
      ])
    }
  },
  props: {
    deviceSpecification: {
      type: Array,
      default: () => []
    },
    productOffering: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    tariffList () {
      return this.$props.productOffering.map(item => item.tariff)
    }
  },
  methods: {
    setTab (tabKey) {
      this.currentTab = tabKey
      setTimeout(() => {
        customEvent.$emit('tab-change')
      }, 350)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .recomended {
  + .tariff-header {
    .add-to-cart-button {
      pointer-events: none;
    }
  }
}
</style>
